import { render } from "./ModalConfirmacaoCampanha.vue?vue&type=template&id=5a32db44&ts=true"
import script from "./ModalConfirmacaoCampanha.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmacaoCampanha.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__